export default __webpack_public_path__ + "static/media/city-hall-mailmarketing-negative.9d8c929c.svg";